import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportsComponent } from './list/reports-list.component';
import { ReportsDetailComponent } from './detail/reports-detail.component';
import { ReportsVisualizationComponent } from './visualization/reports-visualization.component';

const routes: Routes = [
  {
    path: 'reports',
    children: [
      { path: '', component: ReportsComponent }
    ]
  },
  {
    path: 'reports/:id',
    children: [
      { path: '', component: ReportsDetailComponent }
    ]
  },
  {
    path: 'reports/visualization/:id',
    children: [
      { path: '', component: ReportsVisualizationComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
